import { color, layout, space, typography } from "styled-system";

import styled from "styled-components";

const Text = styled.span`
  ${color}
  ${space}
  ${layout}
  ${typography}
  text-decoration: ${(props) => {
    if (props.underline) return "underline";
  }};
  text-transform: ${(props) => {
    if (props.uppercase) return "uppercase";
  }};
`;
Text.defaultProps = {
  fontSize: "inherit",
  fontFamily: "main",
  lineHeight: "inherit",
};
export default Text;
